import type { AccessPermission } from "@entrilia/shared/api/types";

export const pageRoutes = {
  oauth: "oauth",
  logout: "logout",
  loggedOut: "loggedout",
  error: "error",
  systemMaintenance: "system-maintenance",
  clientManagement: "client-management",
  entriliaUsersManagement: "entrilia-users-management",
  agents: "agents",
  observer: "observer",
} as const;

const routeOrder = [
  pageRoutes.systemMaintenance,
  pageRoutes.clientManagement,
  pageRoutes.entriliaUsersManagement,
  pageRoutes.agents,
  pageRoutes.observer,
] as const;

type OpsRoute = (typeof routeOrder)[number];

export const routePermissions: Record<OpsRoute, AccessPermission[]> = {
  [pageRoutes.systemMaintenance]: ["PerformSystemMaintenance", "UseSmartViewsTrace"],
  [pageRoutes.clientManagement]: ["ManageClients", "CopyCompanyData", "PerformSystemMaintenance", "ManageClientUsers"],
  [pageRoutes.entriliaUsersManagement]: ["ManageEntriliaGuestUsers"],
  [pageRoutes.agents]: ["UseOperationsAgents"],
  [pageRoutes.observer]: ["UseOperationsAgents"],
};

export const defaultOpsRoute = (permissions: AccessPermission[]): OpsRoute =>
  routeOrder.find((route) => routePermissions[route].some((p) => permissions.includes(p))) ??
  pageRoutes.systemMaintenance;

export const opsPermissions = [...new Set(Object.values(routePermissions).flat())];
